// Thin wrapper around the shared `api` axios instance. Lives in /admin so
// future migration to a separate admin-frontend repo is one folder move.
import { api } from "@/lib/api";

export const adminApi = api;

export const fetchRbacMeta = () => adminApi.get("/admin/rbac/permissions").then((r) => r.data);
export const fetchAnalytics = () => adminApi.get("/admin/analytics").then((r) => r.data);

export const fetchAdmins = () => adminApi.get("/admin/admins").then((r) => r.data);
export const createAdmin = (payload) => adminApi.post("/admin/admins", payload).then((r) => r.data);
export const updateAdmin = (uid, payload) => adminApi.patch(`/admin/admins/${uid}`, payload).then((r) => r.data);
export const revokeAdmin = (uid) => adminApi.delete(`/admin/admins/${uid}`).then((r) => r.data);

export const fetchAdminLawyers = (params) => adminApi.get("/admin/lawyers", { params }).then((r) => r.data);
export const updateLawyer = (lid, payload) => adminApi.patch(`/admin/lawyers/${lid}`, payload).then((r) => r.data);
export const verifyLawyer = (lid, verified) => adminApi.post(`/admin/lawyers/${lid}/verify`, { verified }).then((r) => r.data);

export const fetchConsultations = (params) => adminApi.get("/admin/consultations", { params }).then((r) => r.data);
export const updateConsultStatus = (cid, status) => adminApi.post(`/admin/consultations/${cid}/status`, { status }).then((r) => r.data);
export const refundConsult = (cid, note = "") => adminApi.post(`/admin/consultations/${cid}/refund`, { note }).then((r) => r.data);

export const fetchAdminUsers = (params) => adminApi.get("/admin/users", { params }).then((r) => r.data);

export const fetchReviews = (params) => adminApi.get("/admin/reviews", { params }).then((r) => r.data);
export const approveReview = (rid, approved) => adminApi.post(`/admin/reviews/${rid}/approve`, { approved }).then((r) => r.data);
export const featureReview = (rid, featured) => adminApi.post(`/admin/reviews/${rid}/feature`, { featured }).then((r) => r.data);
export const deleteReview = (rid) => adminApi.delete(`/admin/reviews/${rid}`).then((r) => r.data);

export const fetchOfferConfig = () => adminApi.get("/pricing/offer").then((r) => r.data);
export const updateOfferPricing = (payload) => adminApi.put("/admin/pricing/offer", payload).then((r) => r.data);
export const updateFirstOffer = (payload) => adminApi.put("/admin/pricing/first-offer", payload).then((r) => r.data);

// ---- 2FA + Security ----
export const start2FA = () => adminApi.post("/admin/auth/2fa/start").then((r) => r.data);
export const verify2FA = (code) => adminApi.post("/admin/auth/2fa/verify", { code }).then((r) => r.data);
export const update2FASettings = (enabled) => adminApi.post("/admin/security/2fa/settings", { enabled }).then((r) => r.data);

export const fetchSecurityLogins = (params) => adminApi.get("/admin/security/logins", { params }).then((r) => r.data);
export const fetchSuspiciousEvents = (params) => adminApi.get("/admin/security/suspicious", { params }).then((r) => r.data);
export const ackSuspicious = (eid) => adminApi.post(`/admin/security/suspicious/${eid}/ack`).then((r) => r.data);
export const fetchActiveSessions = (params) => adminApi.get("/admin/security/sessions", { params }).then((r) => r.data);
export const revokeSession = (token) => adminApi.delete(`/admin/security/sessions/${encodeURIComponent(token)}`).then((r) => r.data);

export const fetchAuditLog = (params) => adminApi.get("/admin/audit-log", { params }).then((r) => r.data);
